import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {RequestServiceProvider} from "../../providers/request-service/request-service";
import {CONFIG} from "../../config/config";

/**
 * Generated class for the InsuranceSelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-insurance-selector',
  templateUrl: 'insurance-selector.html',
})
export class InsuranceSelectorPage {
  public search: string = "";
  public companies: any[] = [];
  public loading: boolean =false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private request: RequestServiceProvider) {
    console.log(this.navParams.data);
  }

  next(company) {
    this.navCtrl.push('BuyInsurancePage', company);
  }

  getInsuranceCompanies() {
    this.loading = true;
      this.request.getInsuranceCompanies().subscribe( companies => {
        this.companies = companies.map( company => {
          return {name: company.name, image: `${CONFIG.laravelUrlTest}/uploads/insurance/${company.image}`}
        });
        this.loading = false;
      })
  }

  get filteredCompanies() {
    return this.companies.filter( company => company.name.toLowerCase().includes(this.search.toLowerCase()))
  }

  ionViewDidLoad() {
    this.getInsuranceCompanies();
  }

}



// WEBPACK FOOTER //
// ./src/pages/insurance-selector/insurance-selector.ts